var actions = {
	next: "下一步",
	confirm: "确认",
	"continue": "继续"
};
var errors = {
	unknown: "发生未知错误",
	contactSupport: "发生错误。请联系支持。",
	tryAgain: "发生错误。请重试。",
	submit: "您的提交有错误。"
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "使用 {name} 登录",
	signupWith: "使用 {name} 注册"
};
var alreadyHaveAccount = {
	company: "已有 {company} 帐户？",
	text: "已经有 Streamlabs ID？",
	link: "登录"
};
var noAccount = {
	text: "还没有帐户？",
	link: "注册"
};
var validation = {
	email: {
		invalid: "请输入有效的电子邮件地址"
	},
	password: {
		required: "需要密码",
		min: "密码必须多于 8 个字符",
		number: "密码必须包含数字",
		upper: "密码必须包含大写字符",
		special: "密码必须包含特殊字符"
	},
	username: {
		invalid: "名称必须至少 5 个字符"
	},
	code: {
		minmax: "代码应为 6 至 10 个字符"
	}
};
var poweredBy = "由 <company>Streamlabs</company> 提供支持";
var card = {
	"404": {
		title: "未找到公司！",
		desc: "请稍后再试或联系支持人员。"
	},
	company: {
		logoAlt: "{company} 徽标"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "6 位授权码/8 位备份码",
	successText: "成功！正在重定向...",
	remember: "记住此设备 30 天"
};
var createTfa = {
	scan: {
		title: "启用双重身份验证",
		lead: "使用您首选的身份验证应用程序点击/复制或扫描下方的代码。我们建议使用 <app0 />、<app1 /> 或 <app2 /> 这样的应用程序安全存储您的代码。",
		copied: "已复制！",
		instructions: "或者手动将此代码输入到您的身份验证应用程序中。",
		copy: "复制代码",
		proceed: "确认"
	},
	confirm: {
		title: "确认您的双重认证",
		lead: "在下方提交生成的 2FA 代码以确认并启用双重认证。",
		label: "双重认证代码（6 位数字）",
		verify: "验证代码",
		next: "成功！下一步"
	},
	save: {
		title: "保存您的恢复代码",
		lead: "将您的恢复代码保存在下方，以防您无法访问双重认证。关闭此模式后，这些代码将不再可用。",
		label: "恢复代码",
		download: "下载恢复代码",
		copied: "代码已复制！",
		finished: "完成"
	}
};
var emailLoginForm = {
	buttonText: "登录",
	emailPlaceholder: "电子邮件",
	passwordPlaceholder: "密码"
};
var emailSignupForm = {
	buttonText: "注册",
	emailPlaceholder: "设置电子邮件",
	passwordPlaceholder: "设置密码",
	usernamePlaceholder: "您的名字",
	ageLabel: "出生日期",
	agePlaceholder: "月/日/年",
	agreeText: "我同意 Streamlabs <terms>服务条款</terms>和<privacy>隐私政策</privacy>。",
	agreeError: "请同意 Streamlabs 条款和条件"
};
var ageInput = {
	invalidDate: "请输入有效的生日",
	futureDate: "出生日期必须在过去",
	minDate: "不允许使用 {year} 年之前的日期",
	minAge_one: "您必须年满 {years} 才能使用 Streamlabs",
	minAge_two: "您必须年满 {years} 才能使用 Streamlabs",
	minAge_other: "您必须年满 {years} 才能使用 Streamlabs"
};
var forgotPasswordForm = {
	emailPlaceholder: "电子邮件",
	back: "返回至登录",
	successText: "成功！我们已向您发送密码重置代码",
	buttonText: "申请重置电子邮件",
	create: {
		successText: "成功！我们已向您发送一个验证码，方便您开始使用！",
		buttonText: "申请验证码"
	},
	errors: {
		notFound: "此电子邮件地址未找到任何帐户"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "忘记密码？",
	lead: "如果您需要重置密码，请在下方输入您的电子邮件，我们将向您发送一封电子邮件以开始该过程。",
	resetTitle: "重置密码",
	resetLead: "您应该已经通过电子邮件收到了代码。填写表格以重置您的密码。",
	create: {
		title: "创建您的密码",
		lead: "恭喜您创建 Streamlabs ID！只需再操作一步，您就可以登录所有 Streamlabs！",
		resetTitle: "选择一个密码",
		resetLead: "您应该已经通过电子邮件收到了代码。使用此代码并填写表格以设置密码。"
	},
	successText: "成功！正在重定向...",
	signInTitle: "已有帐户？",
	signInBtn: "登录"
};
var checkTfaCard = {
	title: "双重身份验证检查",
	lead: "请在下方输入双重认证代码以继续。",
	successText: "双重认证确认成功！",
	back: "返回"
};
var verifyEmailCard = {
	title: "验证您的电子邮件",
	lead: "查看您的电子邮件以获取来自 Streamlabs 的 8 位代码并在下方输入。",
	back: "返回",
	successText: "电子邮件验证成功！"
};
var upgradeCard = {
	confirm: {
		title: "确认 {company} 连接",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"今后，您将可以使用提供的电子邮件和密码登录 {company}。",
			"您可以使用您的 ID 从 Streamlabs 访问所有其他产品，并连接其他现有帐户（如果有）。",
			"您的 {company} 帐户不会受到此更改的影响。"
		],
		button: "确认",
		cancel: "取消",
		switchAccount: "切换帐户",
		success: "正在连接..."
	},
	confirmed: {
		title: "成功！",
		subtitle: "您的 Streamlabs ID 已创建并且 {company} 帐户已连接。",
		text: "您可以将您的 Streamlabs ID 用于所有 Streamlabs 产品。如果您有现有帐户，则可以在每个应用程序中将它们连接到此 ID。",
		button: "关闭"
	},
	error: {
		user: "用户识别失败。请重新尝试登陆或联系支持人员。"
	}
};
var confirmCard = {
	confirm: {
		title: "确认 {company} 连接",
		subtitle: "我们找到了一个具有匹配电子邮件的帐户。是否要想将此帐户与 Streamlabs ID 合并？",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"您将可以使用您通过 Streamlabs ID 提供的电子邮件和密码登录 {company}。",
			"您可以使用您的 ID 从 Streamlabs 访问所有其他产品，并连接其他现有帐户（如果有）。",
			"您的公司帐户不会受到此更改的影响。"
		],
		button: "确认",
		cancel: "取消",
		switchAccount: "切换帐户",
		success: "正在连接..."
	},
	confirmed: {
		title: "成功！",
		subtitle: "您的 Streamlabs ID 已创建并且 {company} 帐户已连接。",
		text: "您可以将您的 Streamlabs ID 用于所有 Streamlabs 产品。如果您有现有帐户，则可以在每个应用程序中将它们连接到此 ID。",
		button: "关闭"
	},
	error: {
		user: "用户识别失败。请重新尝试登陆或联系支持人员。"
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " 您的 ID 已有已连接的 {company} 帐户",
		subtitle: "是否要取消关联帐户并链接到您当前的 Streamlabs 帐户？",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"您将可以使用您为 Streamlabs ID 提供的电子邮件和密码登录 Streamlabs。",
			"您可以使用您的 ID 从 Streamlabs 访问所有其他产品，并连接其他现有帐户（如果有）。",
			"您的 Streamlabs 帐户不会受到此更改的影响。"
		],
		button: "确认",
		cancel: "取消",
		switchAccount: "切换帐户",
		success: "正在连接...",
		agreeLabel: "我知晓，通过建立此连接，我将无法访问绑定到 Streamlabs ID 的现有 {company} 帐户。"
	},
	confirmed: {
		title: "成功！",
		subtitle: "您的 Streamlabs ID 已创建并且 {company} 帐户已连接。",
		text: "您可以将您的 Streamlabs ID 用于所有 Streamlabs 产品。如果您有现有帐户，则可以在每个应用程序中将它们连接到此 ID。",
		button: "关闭"
	},
	error: {
		user: "用户识别失败。请重新尝试登陆或联系支持人员。"
	}
};
var loginCard = {
	title: "登录",
	lead: "使用 <id>Streamlabs ID</id> 登录到 <company>{company}</company>",
	accountExists: "看起来您已经拥有 <b>Streamlabs ID</b>。请尝试使用您的电子邮件登录。",
	forgotPassword: "忘记密码？",
	successText: "成功！正在重定向...",
	signInTitle: "使用平台登录"
};
var loginSourcesCard = {
	title: "登录",
	lead: "使用电子邮件/密码登录",
	withSlId: "使用 Streamlabs ID 登录",
	noAccountMessage: "我们没有看到与此登录方法关联的帐户。请尝试不同的登录方式，如果您没有帐户，请<signup>注册</signup>。",
	accountExistsMessage: "您的 Twitch 电子邮件地址已与 Streamlabs 关联。请尝试使用您的 Streamlabs 电子邮件和密码登录。"
};
var resetPasswordForm = {
	emailPlaceholder: "电子邮件",
	codePlaceholder: "6-8 位电子邮件代码",
	tfaCodePlaceholder: "双重认证代码",
	newPasswordPlaceholder: "新密码",
	tfaError: "重置代码应为 6 至 10 个字符",
	next: "已收到验证码？",
	back: "返回至忘记密码",
	buttonText: "更改密码",
	successText: "密码重置成功",
	create: {
		back: "返回至开始",
		buttonText: "设置密码",
		successText: "密码设置成功"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "当前密码",
	newPasswordPlaceholder: "新密码",
	newPasswordConfirmationPlaceholder: "确认新密码",
	buttonText: "更改密码",
	successText: "密码更新成功",
	newPasswordConfirmationError: "新密码不一致",
	back: "返回仪表板"
};
var changePasswordCard = {
	title: "更改您的密码",
	lead: "在下方输入您的当前密码和新密码。",
	successText: "密码更新成功"
};
var removeTfaForm = {
	tfaCodePlaceholder: "6 位授权码/8 位备份码",
	successText: "双重认证移除成功！",
	removeBtn: "确认并移除"
};
var removeTfaCard = {
	title: "移除双重身份验证",
	lead: "在下方输入双重认证确认码以从您的帐户中移除双重认证。",
	successText: "双重认证移除成功！",
	back: "返回仪表板"
};
var verifyEmailForm = {
	codePlaceholder: "来自电子邮件的 8 位代码",
	tfaCodePlaceholder: "双重认证代码",
	emailPlaceholder: "电子邮件地址",
	buttonText: "验证电子邮件",
	successText: "电子邮件验证成功",
	requestBtn: "申请新代码",
	requestingBtn: "正在申请...",
	requestSuccess: "代码已发送到您的电子邮箱",
	requestAgain: "{seconds} 秒后再次申请",
	tfaError: "重置代码应为 6 至 10 个字符",
	back: "返回"
};
var signupCard = {
	title: "注册",
	lead: "创建一个 <id>Streamlabs ID</id> 帐户以使用 <company>{company}</company>",
	successText: "成功！正在重定向..."
};
var signupSourcesCard = {
	title: "注册",
	lead: "创建一个 <id>Streamlabs ID</id> 帐户以使用 <company>{company}</company>",
	withSlId: "创建一个 Streamlabs ID"
};
var connectCard = {
	connect: {
		title: "选择一个帐户",
		lead: "以继续使用 <b>{company}</b>",
		authorize: "授权",
		authorizeSuccess: "成功！",
		cancel: "取消",
		disclaimer: {
			streamlabs: "继续下一步，将与 <b>{company}</b> 共享您的 Streamlabs ID（姓名、电子邮件地址、语言偏好和个人资料图片）。授权 <b>{company}</b> 帐户，即代表您同意 <b>{company}</b> 的<privacy>隐私政策</privacy>和<terms>服务条款</terms>。",
			"default": "要继续，Streamlabs 将与 <b>{company}</b> 共享您的姓名、电子邮件地址、语言偏好和个人资料图片。授权 <b>{company}</b> 帐户，即代表您同意 <b>{company}</b> 的<privacy>隐私政策</privacy>和<terms>服务条款</terms>。"
		},
		emailRequired: "在继续之前需要验证电子邮件",
		tfaRequired: "在继续之前需要进行双重认证"
	},
	login: {
		title: "登录至 {company}",
		lead: "要连接帐户，您必须先登录",
		loginBtn: "继续登录"
	},
	error: {
		title: "登录至 {company}",
		lead: "目前无法授权您的请求。",
		verifyEmail: "验证电子邮件",
		verify2fa: "验证 2FA"
	},
	"switch": {
		btn: "使用其他帐户"
	}
};
var appsDropdown = {
	label: "Streamlabs 产品和应用程序",
	viewMore: "扩展",
	viewLess: "收缩"
};
var platformButtons = {
	loginWithPlatform: "使用平台登录",
	signUpWithPlatform: "使用平台注册",
	signUpLead: "我们支持更多平台的直播，这些只是注册选项。"
};
var ultraCheckoutCard = {
	title: "加入 <b>Streamlabs Ultra</b>，提升您的直播、品牌、编辑以及更多",
	badge: "包含 <b>{planName}</b>",
	totalValue: "{price, currency} 价值",
	price: {
		month: "{price, currency}/月",
		year: "{price, currency}/年"
	},
	description: {
		month: "只需一个订阅，即可访问全套软件的高级功能，包括 <b>Streamlabs Desktop</b>、<b>Console</b>、<b>Talk Studio</b>、<b>Podcast Editor</b>、<b>Cross Clip</b> 等等，价格实惠量又足。",
		year: "只需一个订阅，即可访问全套软件的高级功能，包括 <b>Streamlabs Desktop</b>、<b>Console</b>、<b>Talk Studio</b>、<b>Podcast Editor</b>、<b>Cross Clip</b> 等等，价格实惠量又足。"
	},
	seeIncluded: "了解更多",
	buyNow: "升级"
};
var ultraCheckoutBanner = {
	title: "加入 <b>Streamlabs Ultra</b>，提升您的直播、品牌、编辑以及更多",
	badge: "包含 <b>{planName}</b>",
	totalValue: "{price, currency} 价值",
	price: {
		month: "{price, currency}/月",
		year: "{price, currency}/年"
	},
	description: {
		month: "只需一个订阅，即可访问全套软件的高级功能，包括 <b>Streamlabs Desktop</b>、<b>Console</b>、<b>Talk Studio</b>、<b>Podcast Editor</b>、<b>Cross Clip</b> 等等，价格实惠量又足。 <link />",
		year: "只需一个订阅，即可访问全套软件的高级功能，包括 <b>Streamlabs Desktop</b>、<b>Console</b>、<b>Talk Studio</b>、<b>Podcast Editor</b>、<b>Cross Clip</b> 等等，价格实惠量又足。 <link />"
	},
	seeIncluded: "了解更多",
	buyNow: "升级"
};
var connect = {
	waitMessage: "合并数据。请不要关闭此窗口。"
};
var verifyPasswordCard = {
	success: "密码验证成功",
	title: "请重新认证以验证",
	lead: "使用现有电子邮件和密码登录，以继续更新您的 Streamlabs ID。",
	buttonText: "下一步"
};
var emailChangeForm = {
	agreeError: "请核实您是否理解此操作",
	buttonText: "下一步",
	emailPlaceholder: "新电子邮件地址",
	agreeText: "我明白，通过验证后，我的 Streamlabs ID 将在其连接的所有 Streamlabs 产品上发生变化。"
};
var verifyNewEmailCard = {
	title: "更改您的 Streamlabs ID",
	lead: "提供一个新的电子邮件作为您的 Streamlabs ID。我们将向该地址发送一个 6-8 位数的验证码。",
	successText: "新电子邮件可用"
};
var verifyNewEmailOwnershipCard = {
	title: "验证您更新的 Streamlabs ID",
	lead: "查看您的电子邮件以获取来自 Streamlabs 的 8 位代码并在下方输入。",
	buttonText: "确认",
	back: "返回",
	codePlaceholder: "来自电子邮件的 8 位代码",
	successText: "电子邮件所有权验证成功"
};
var verifyTfaCard = {
	title: "双重身份验证代码",
	lead: "输入验证应用程序中的 6 位验证码。",
	codePlaceholder: "6 位数代码",
	buttonText: "确认",
	successText: "双重身份验证已确认",
	back: "返回"
};
var ageGateForm = {
	ageLabel: "出生日期",
	agePlaceholder: "月/日/年"
};
var ageGateCard = {
	title: "完成账户设置",
	lead: {
		years: "您必须年满 {years} 才能创建账户。<br />输入您的出生日期以完成设置。",
		noYears: "您必须提供出生日期才能创建账户。<br />输入以完成设置。"
	},
	successText: "祝贺您！账户设置完成。"
};
var zhCN = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { zhCN as z };
//# sourceMappingURL=zh-CN.es.js.map
